import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Chip } from '@material-ui/core';
import { Chat } from '@material-ui/icons';
import { openTaskChatDialog } from './redux';
import { withChatBoundary } from './ChatErrorBoundary';
import { chatColors, chatIndicator, chatUnreadCount } from './chatState';

const taskTypeTask = 3;
const labels = { none: 'Чат', waiting: 'Не е поет', unread: 'Непрочетено', seen: 'Видяно' };

// Чипът в лентата на картата — бял (лентата на някои задачи е червена), с цвят на иконката и текста: сив „Чат" — по
// задачата няма активен чат (започва се оттук, без затваряне на задачата), сив „Не е поет" — координатор още не е поел
// чата, червен „Непрочетено (броят)", зелен „Видяно".
const TaskChatChip = ({ task }) => {
  const dispatch = useDispatch();
  const enabled = useSelector(state => state.chat.enabled);
  const isTaskChat = x => x.scheduleTaskId === Number(task.id);
  const indicator = useSelector(state => chatIndicator(state.chat, isTaskChat));
  const count = useSelector(state => chatUnreadCount(state.chat, isTaskChat));

  if (!enabled || (indicator === 'none' && task.type !== taskTypeTask)) return null;

  const color = chatColors[indicator];

  return (
    <Chip
      style={{ margin: '1px', marginRight: '2px', backgroundColor: '#fff', color }}
      avatar={<Chat style={{ color }} />}
      label={count ? `${labels[indicator]} (${count})` : labels[indicator]}
      onClick={() => dispatch(openTaskChatDialog(task))}
      clickable
    />
  );
};

export default withChatBoundary(TaskChatChip);
